module.exports = __webpack_public_path__ + "static/media/heart.b4af837c.svg";